import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../../common_components/Header";
import DatePicker from "react-datepicker";
import Footer from "../../common_components/Footer";
import Drawer from "../../common_components/Drawer";
import {
    getUserHotelEnquiry_action,
    insertHotelEnquiry_action
} from "../../actions/exhibitor_module_actions/hotel_form_action/hotel_form_action";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import HeaderLogin from '../../common_components/HeaderLogin';
import { ToastContainer, toast } from "react-toastify";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import Loader from "../../utils/Loader";
import {
    clearSessionStorage,
    countryActionId,
    stateActionId,
    cityActionId,
    pincodeActionId,
    RoomTypeActionId,
    toastError, GSTvalidationActionId,
    toastSuccess, countryIWithCodeActionId
} from "../../utils/constants";
import Pagination from "../../utils/pagination";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from "../../actions/fillCombo_action";
import StepHeader from "./stepHeader";
import PrimaryChapter from "./primary_chapter";
import Description from "./description";
import Resizer from "react-image-file-resizer";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../utils/Validator";
import $ from "jquery";
import {
    getHotelDetails_action,
} from "../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/hotelEnquiry_action/hotelEnquiry_action";
import VisitorHeader2 from "../../common_components/visitor_module_header2";
import VisitorDrawer from "../../common_components/visitor_module_drawer";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";
import VisitorTopMenu from "../../common_components/visitor_module_topmenu";
import {
    insertUpdateHotelBookinForm_action, getHotelBookinFormDetails_action
} from "../../actions/hotelBookingForm_action/hotelBookingForm_action";
import HeaderWithLogo from "../../common_components/header_with_logo";
import AdminDrawer from "../../common_components/admin_module_drawer";
/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps getUserHotelEnquiry_action
insertHotelEnquiry_action
*/
const mapStateToProps = state => ({
    ...state
})

class HotelBookingForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            isOpenConfirmationModal: false,
            exhID: '',
            EventDate: '',
            SetupDate: '',
            DismantleDate: '',
            ExhibitionAddress: '',
            HotelDetailsList: [],
            isOpen: false,
            RoleID: sessionStorage.getItem("RoleIDSS"),
            FirstName: '',
            FirstNameErr: '',
            LastName: '',
            LastNameErr: '',
            EmailId: '',
            EmailIdErr: '',
            CountryId: '',
            CountryErr: '',
            MobileNo: '',
            MobileNoErr: '',
            NumberofRooms: '',
            MobileNoErr: '',
            NumberofRoomsList: [],
            countryList: [],
            preMobNo: '',
            RoomTypeList: [],
            HotelBookingFormHdrID: null,
            is_view: false,
            isExhibitiorOrVisitor: sessionStorage.getItem("RoleIDSS") == 1 || sessionStorage.getItem("RoleIDSS") == 3
        }
        this.getFillList = this.getFillList.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.inputValidation = this.inputValidation.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.onCancleForm = this.onCancleForm.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.handleSubmit()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }
    componentDidMount() {
        this.getFillList(countryActionId, '', '', '', '')
        this.getFillList(RoomTypeActionId, '', '', '', '')
        this.setState({
            from: this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : null,
            exhID: this.props.location.state != null && this.props.location.state.exhID ? this.props.location.state.exhID : null,
            HotelBookingFormHdrID: this.props.location.state != null && this.props.location.state.HotelBookingFormHdrID ? this.props.location.state.HotelBookingFormHdrID : null,
            is_view: this.props.location.state != null && this.props.location.state.is_view ? this.props.location.state.is_view : false,
        }, () => {
            this.getDetails()
            this.getHotelDetails()
            this.getHotelBookinFormDetails()
            window.scrollTo(0, 0);
        })
    }

    getHotelDetails() {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .getHotelDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, HotelDetailsList: data.data })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getHotelBookinFormDetails() {
        const { HotelBookingFormHdrID } = this.state;

        if (!HotelBookingFormHdrID) return;

        this.setState({ isLoading: true });

        this.props
            .getHotelBookinFormDetails_action(HotelBookingFormHdrID)
            .then((data) => {
                if (data.error !== 1 && data.data?.length > 0) {

                    const header = data.data[0]?.[0] || {};
                    const roomList = data.data[1] || [];
                    const memberList = data.data[2] || [];

                    // Mobile split
                    let mobArr = header.MobileNo
                        ? header.MobileNo.split("-")
                        : [];

                    let preMobNo = mobArr.length === 2 ? mobArr[0] : "";
                    let MobileNo = mobArr.length === 2 ? mobArr[1] : mobArr[0] || "";

                    // Prepare room list with members
                    const NumberofRoomsList = roomList.map((room, index) => {
                        const roomMembers = memberList
                            .filter(
                                (m) =>
                                    m.HotelBookingFormDtlID ===
                                    room.HotelBookingFormDtlID
                            )
                            .map((member) => ({
                                HotelBookingFormMemberDtlID:
                                    member.HotelBookingFormMemberDtlID,
                                FirstName: member.FirstName || "",
                                LastName: member.LastName || "",
                                FirstNameErr: "",
                                LastNameErr: ""
                            }));

                        return {
                            HotelBookingFormDtlID: room.HotelBookingFormDtlID,
                            roomNumber: index + 1,
                            checkInDate: room.CheckIn
                                ? new Date(room.CheckIn)
                                : null,
                            checkOutDate: room.CheckOut
                                ? new Date(room.CheckOut)
                                : null,
                            RoomTypeId: room.RoomTypeID || "",
                            checkInDateErr: "",
                            checkOutDateErr: "",
                            RoomTypeIdErr: "",
                            RoomMemberList: roomMembers
                        };
                    });

                    this.setState({
                        isLoading: false,

                        // Header Data
                        FirstName: header.FirstName || "",
                        LastName: header.LastName || "",
                        EmailId: header.EmailID || "",
                        CountryId: header.CountryID || "",
                        preMobNo: preMobNo,
                        MobileNo: MobileNo,
                        NumberofRooms: header.NumberofRooms || 0,

                        // Room Data
                        NumberofRoomsList: NumberofRoomsList
                    });

                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }

    getDetails() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, EventDate, DismantleDate, SetupDate, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state        // this.setState({ isLoading: true })
        this.props
            .getUserHotelEnquiry_action(exhID) // DYNAMIC PARAMS HAS TO BE PLACE LATER <<==
            .then((data) => {
                if (data.error != 1) {
                    var mobNo = data.data[0][0].MobileNo != '' && data.data[0][0].MobileNo != null ? data.data[0][0].MobileNo.split('-') : []
                    var preMob = mobNo.length == 2 ? mobNo[0] : ''
                    var mobNo1 = mobNo.length == 2 ? mobNo[1] : mobNo.length == 1 ? mobNo[0] : ''
                    this.setState({
                        Name: data.data[0][0].PersonIncharge,
                        companyName: data.data[0][0].CompanyName,
                        DismantleDate: data.data[0][0].DismantleDate,
                        EventDate: data.data[0][0].EventDate,
                        mobNo: mobNo1,
                        preMobNo: preMob,
                        Email: data.data[0][0].PrimaryEmail,
                        SetupDate: data.data[0][0].SetupDate,
                        ExhibitionAddress: data.data[0][0].ExhibitionAddress
                    })
                }
            }).catch(e => {
                console.log(e)
            })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID == countryActionId) {
                        this.setState({ countryList: data.data })
                    }
                    if (actionID == RoomTypeActionId) {
                        this.setState({ RoomTypeList: data.data })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    handleSubmit = async () => {
        try {
            const {
                FirstName,
                LastName,
                EmailId,
                CountryId,
                MobileNo,
                NumberofRooms,
                NumberofRoomsList,
                preMobNo,
                HotelBookingFormHdrID
            } = this.state;

            const res = await this.inputValidation();

            if (res) {
                toastError("Please fill mandatory fields");
                return;
            }

            this.setState({ isLoading: true });

            const finalMobNo = preMobNo
                ? `${preMobNo}-${MobileNo}`
                : MobileNo;

            const data = await this.props.insertUpdateHotelBookinForm_action(
                1,
                HotelBookingFormHdrID,
                FirstName,
                LastName,
                EmailId,
                CountryId,
                finalMobNo,
                NumberofRooms,
                NumberofRoomsList
            );

            if (data.error !== 1) {
                toastSuccess("Form Submitted Successfully");
                setTimeout(() => {
                    this.props.navigate(-1);
                }, 1000);
            }

        } catch (error) {
            console.log("Error:", error);
            toastError("Something went wrong");
        } finally {
            this.setState({ isLoading: false });
        }
    };

    inputValidation() {
        const { FirstName, LastName, EmailId, CountryId, MobileNo, NumberofRooms, NumberofRoomsList } = this.state
        return new Promise((resolve) => {
            let hasError = false

            if (!FirstName.trim()) {
                this.setState({ FirstNameErr: "Please Enter First Name" })
                hasError = true
            }
            if (!LastName.trim()) {
                this.setState({ LastNameErr: "Please Enter Last Name" })
                hasError = true
            }
            if (!EmailId.trim()) {
                this.setState({ EmailIdErr: "Please Enter Email" })
                hasError = true
            }
            if (!CountryId) {
                this.setState({ CountryErr: "Please Select Country" })
                hasError = true
            }
            if (!MobileNo.trim()) {
                this.setState({ MobileNoErr: "Please Enter Mobile No" })
                hasError = true
            }
            if (!NumberofRooms || parseInt(NumberofRooms) <= 0) {
                this.setState({ NumberofRoomsErr: "Please Enter Number of Rooms" })
                hasError = true
            }

            // Validate each room
            const updatedRoomList = NumberofRoomsList.map((room, index) => {
                let roomErr = { ...room }
                if (!room.checkInDate) {
                    roomErr.checkInDateErr = "Please Select Check In Date"
                    hasError = true
                } else {
                    roomErr.checkInDateErr = ""
                }
                if (!room.checkOutDate) {
                    roomErr.checkOutDateErr = "Please Select Check Out Date"
                    hasError = true
                } else {
                    roomErr.checkOutDateErr = ""
                }
                if (!room.RoomTypeId) {
                    roomErr.RoomTypeIdErr = "Please Select Room Type"
                    hasError = true
                } else {
                    roomErr.RoomTypeIdErr = ""
                }

                // Validate members
                const updatedMembers = (room.RoomMemberList || []).map((member) => {
                    let memberErr = { ...member }
                    if (!member.FirstName || !member.FirstName.trim()) {
                        memberErr.FirstNameErr = "Please Enter First Name"
                        hasError = true
                    } else {
                        memberErr.FirstNameErr = ""
                    }
                    if (!member.LastName || !member.LastName.trim()) {
                        memberErr.LastNameErr = "Please Enter Last Name"
                        hasError = true
                    } else {
                        memberErr.LastNameErr = ""
                    }
                    return memberErr
                })

                roomErr.RoomMemberList = updatedMembers
                return roomErr
            })

            this.setState({ NumberofRoomsList: updatedRoomList })
            resolve(hasError)
        })
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }


    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    onCancleForm(e) {
        e.preventDefault()
        this.props.navigate(-1)
    }

    handleRoomChange = (index, field, value) => {
        this.setState(prevState => {
            const list = [...prevState.NumberofRoomsList];
            list[index] = { ...list[index], [field]: value, [`${field}Err`]: "" };
            return { NumberofRoomsList: list };
        });
    };

    handleMemberChange = (roomIndex, memberIndex, field, value) => {
        this.setState(prevState => {
            const updatedList = [...prevState.NumberofRoomsList];
            updatedList[roomIndex] = {
                ...updatedList[roomIndex],
                RoomMemberList: updatedList[roomIndex].RoomMemberList.map((member, i) => {
                    if (i === memberIndex) {
                        return { ...member, [field]: value, [`${field}Err`]: "" };
                    }
                    return member;
                })
            };
            return { NumberofRoomsList: updatedList };
        });
    };

    handleRoomTypeChange = (index, roomTypeId, id) => {
        const getRoomMembers = (type) => {
            const count = type == 1 ? 1 : 2;
            return Array.from({ length: count }, (_, i) => ({
                memberId: i + 1,
                ID:id
            }));
        };

        this.setState(prevState => {
            const list = [...prevState.NumberofRoomsList];
            list[index] = {
                ...list[index],
                RoomTypeId: roomTypeId,
                RoomTypeIdErr: "",
                RoomMemberList: getRoomMembers(roomTypeId)
            };
            return { NumberofRoomsList: list };
        });
    };

    render() {
        const {
            isLoading,
            isOpenConfirmationModal,
            exhID,
            EventDate,
            SetupDate,
            DismantleDate,
            ExhibitionAddress,
            HotelDetailsList,
            isOpen,
            RoleID,
            FirstName,
            FirstNameErr,
            LastName,
            LastNameErr,
            EmailId,
            EmailIdErr,
            CountryId,
            CountryErr,
            MobileNo,
            MobileNoErr,
            NumberofRooms,
            NumberofRoomsErr,
            NumberofRoomsList,
            countryList,
            preMobNo,
            RoomTypeList,
            isExhibitiorOrVisitor,
            is_view
        } = this.state
        console.log("NumberofRoomsList--------->",NumberofRoomsList)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <>
                    {isExhibitiorOrVisitor &&
                        <>
                            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                                <ExhibitorHeader />
                            ) : (
                                <VisitorHeader2 />
                            )}
                            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                                <ExhibitorDrawer />
                            ) :
                                <VisitorDrawer />
                            }
                        </>
                    }
                    {/* PAGE */}
                    <div
                        className={"with-dr-container"}
                        style={{ marginTop: RoleID == 1 ? "50px" : "20px" }}
                    >
                        <div className="main-container">
                            {isExhibitiorOrVisitor ?
                                <>
                                    <div className="row">
                                        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                                            1 ? (
                                            <ExhibitorTopMenu />
                                        ) : <VisitorTopMenu />}
                                    </div>
                                </> :
                                <>
                                    <AdminDrawer />
                                    <HeaderWithLogo />
                                    <div class="row m-0">
                                        <div className="bookingForm-breadcrumb-scroll-fixed">
                                            <h6 className="mb-0 p-2 text-white">Hotel BookingForm</h6>
                                        </div>
                                    </div>
                                </>
                            }
                            {/* {from == 'dashboard' ? <ExhibitorHeader /> : isDataLoad ? <HeaderLogin /> : null}
                            {from == 'dashboard' ? <ExhibitorDrawer /> : null} */}

                            <div style={{ marginTop: isExhibitiorOrVisitor ? "" : "100px" }}>
                                <div className="side-app">
                                    <div className="container-fluid mt-top-space p-0" >
                                        <div className="row justify-content-center">
                                            <div className="col-xl-12 col-lg-11 col-md-12">

                                                <div className="card border-0 shadow-none hb-card">
                                                    <div className="card-body p-3">

                                                        {/* Header banner */}
                                                        <div className="hb-hero">
                                                            <span className="hb-hero-icon"><i className="fa fa-bed"></i></span>
                                                            <div>
                                                                <h3 className="hb-hero-title">BOOKING FORM</h3>
                                                                <p className="hb-hero-sub">Book your stay{sessionStorage.getItem("sessionExhibitionName") ? ` for ${sessionStorage.getItem("sessionExhibitionName")}` : ''} with ease</p>
                                                            </div>
                                                        </div>

                                                        {/* Event details: three tiles */}
                                                        <div className="hb-info">
                                                            <div className="hb-tile hb-tile-green">
                                                                <span className="hb-tile-icon"><i className="fa fa-calendar"></i></span>
                                                                <div><div className="hb-tile-label">Setup Date</div><div className="hb-tile-value">{SetupDate || "-"}</div></div>
                                                            </div>
                                                            <div className="hb-tile hb-tile-blue">
                                                                <span className="hb-tile-icon"><i className="fa fa-calendar-check-o"></i></span>
                                                                <div><div className="hb-tile-label">Event Date</div><div className="hb-tile-value">{EventDate || "-"}</div></div>
                                                            </div>
                                                            <div className="hb-tile hb-tile-orange">
                                                                <span className="hb-tile-icon"><i className="fa fa-map-marker"></i></span>
                                                                <div><div className="hb-tile-label">Venue</div><div className="hb-tile-value">{ExhibitionAddress || "-"}</div></div>
                                                            </div>
                                                        </div>

                                                        {/* Personal Info */}
                                                        <div className="hb-section">
                                                            <div className="hb-section-head">
                                                                <span className="hb-section-icon"><i className="fa fa-user"></i></span>
                                                                <div className="flex-grow-1">
                                                                    <h6 className="hb-section-title">Enter Your Details</h6>
                                                                    <div className="hb-section-sub">Please provide the following information to proceed with your booking.</div>
                                                                </div>
                                                                <span className="hb-mandatory"><span className="text-danger">*</span> Indicates mandatory fields</span>
                                                            </div>
                                                            <div className="row g-3">
                                                                <div className="col-md-4">
                                                                    <label className="form-label">First Name <span className="text-danger">*</span></label>
                                                                    <div className="hb-input"><i className="fa fa-user-o"></i>
                                                                        <input type="text" className="form-control" placeholder="Enter first name"
                                                                            disabled={is_view} value={FirstName} maxLength="200"
                                                                            onChange={(e) => this.setState({ FirstName: e.target.value, FirstNameErr: "" })}
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">{FirstNameErr}</span>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                                                    <div className="hb-input"><i className="fa fa-user-o"></i>
                                                                        <input type="text" className="form-control" placeholder="Enter last name"
                                                                            disabled={is_view} value={LastName} maxLength="200"
                                                                            onChange={(e) => this.setState({ LastName: e.target.value, LastNameErr: "" })}
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">{LastNameErr}</span>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Email <span className="text-danger">*</span></label>
                                                                    <div className="hb-input"><i className="fa fa-envelope-o"></i>
                                                                        <input type="text" className="form-control" placeholder="Enter email address"
                                                                            disabled={is_view} value={EmailId} maxLength="200"
                                                                            onChange={(e) => this.setState({ EmailId: e.target.value, EmailIdErr: "" })}
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">{EmailIdErr}</span>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Country <span className="text-danger">*</span></label>
                                                                    <div className="hb-input"><i className="fa fa-globe"></i>
                                                                        <select className="form-control" disabled={is_view} value={CountryId}
                                                                            onChange={(e) => {
                                                                                // ISD box follows the selected country (countryList's CountryCode, shown with "+")
                                                                                const country = countryList.find(c => String(c.Code) === String(e.target.value))
                                                                                const code = country && country.CountryCode ? String(country.CountryCode).trim() : ''
                                                                                this.setState({
                                                                                    CountryId: e.target.value,
                                                                                    CountryErr: "",
                                                                                    preMobNo: code ? (code.startsWith('+') ? code : `+${code}`) : ''
                                                                                })
                                                                            }}>
                                                                            <option value={''}>Select Country</option>
                                                                            {countryList.length > 0 && countryList.map(data => (
                                                                                <option value={data.Code} key={data.Code}>{data.Description}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <span className="text-danger">{CountryErr}</span>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Mobile No <span className="text-danger">*</span></label>
                                                                    <div className="phone-input-group hb-phone">
                                                                        <input type="text" className="form-control phone-code" autoComplete="off" readOnly placeholder="ISD" value={preMobNo || ''} />
                                                                        <div className="hb-input flex-grow-1"><i className="fa fa-phone"></i>
                                                                            <input type="text" className="form-control phone-no" placeholder="Enter mobile number"
                                                                                disabled={is_view} value={MobileNo} maxLength="10"
                                                                                onChange={(e) => /^[0-9]*$/.test(e.target.value) ? this.setState({ MobileNo: e.target.value, MobileNoErr: "" }) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <span className="text-danger">{MobileNoErr}</span>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Number of Rooms <span className="text-danger">*</span></label>
                                                                    <div className="hb-input"><i className="fa fa-building-o"></i>
                                                                        <input type="text" className="form-control" placeholder="Enter number of rooms"
                                                                            disabled={is_view} value={this.state.NumberofRooms} maxLength="2"
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                this.setState({ NumberofRooms: value, NumberofRoomsErr: "" }, () => {
                                                                                    const count = parseInt(value) || 0;
                                                                                    this.setState(prevState => {
                                                                                        let updatedList = [...prevState.NumberofRoomsList];
                                                                                        if (updatedList.length < count) {
                                                                                            for (let i = updatedList.length; i < count; i++) {
                                                                                                updatedList.push({ roomNumber: i + 1, checkInDate: null, checkOutDate: null, RoomTypeId: '', RoomMemberList: [], ID: updatedList.length + 1 });
                                                                                            }
                                                                                        } else if (updatedList.length > count) {
                                                                                            updatedList = updatedList.slice(0, count);
                                                                                        }
                                                                                        return { NumberofRoomsList: updatedList };
                                                                                    });
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">{NumberofRoomsErr}</span>
                                                                </div>
                                                            </div>
                                                        </div>

<div className={this.state.NumberofRoomsList.length > 0 ? "row mt-3" : "row"}>
                                                            {this.state.NumberofRoomsList.map((room, index) => (
                                                                <div className="col-md-4 mb-3" key={index}>
                                                                    <div className="card shadow-sm">
                                                                        <div className="card-header text-white" style={{ background: '#3dbca7' }}>
                                                                            Room {room.roomNumber}
                                                                        </div>

                                                                        <div className="card-body">

                                                                            {/* Check In */}
                                                                            <div className="form-group mb-2">
                                                                                <label>Check In<span className="text-danger">*</span></label>
                                                                                <DatePicker
                                                                                    selected={room.checkInDate}
                                                                                    className="form-control"
                                                                                    disabled={is_view}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    onChange={(date) =>
                                                                                        this.handleRoomChange(index, "checkInDate", date)
                                                                                    }
                                                                                />
                                                                                <span className="text-danger">{room.checkInDateErr}</span>
                                                                            </div>

                                                                            {/* Check Out */}
                                                                            <div className="form-group mb-3">
                                                                                <label>Check Out<span className="text-danger">*</span></label>
                                                                                <DatePicker
                                                                                    selected={room.checkOutDate}
                                                                                    className="form-control"
                                                                                    disabled={is_view}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    onChange={(date) =>
                                                                                        this.handleRoomChange(index, "checkOutDate", date)
                                                                                    }
                                                                                />
                                                                                <span className="text-danger">{room.checkOutDateErr}</span>
                                                                            </div>

                                                                            {/* Room Type */}
                                                                            <div className="form-group mb-2">
                                                                                <label>Room Type<span className="text-danger">*</span></label>
                                                                                <select className="form-control"
                                                                                    disabled={is_view}
                                                                                    value={room.RoomTypeId}
                                                                                    onChange={(e) =>
                                                                                        this.handleRoomTypeChange(index, e.target.value, room.ID)
                                                                                    }
                                                                                >
                                                                                    <option value={''}>Select</option>
                                                                                    {
                                                                                        RoomTypeList.length > 0 && RoomTypeList.map(data => (
                                                                                            <option value={data.RoomTypeID} key={data.RoomTypeID}>{data.RoomTypeName}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                                <span className="text-danger">{room.RoomTypeIdErr}</span>
                                                                            </div>

                                                                            {/* Members */}
                                                                            {room.RoomMemberList.length > 0 && (
                                                                                <div>
                                                                                    <strong>Members<span className="text-danger">*</span></strong>

                                                                                    {room.RoomMemberList.map((member, mIndex) => (
                                                                                        <div key={mIndex} className="border p-2 mb-2 rounded">
                                                                                            <div className="row">

                                                                                                {/* First Name */}
                                                                                                <div className="col-md-6">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        disabled={is_view}
                                                                                                        placeholder="First Name"
                                                                                                        value={member.FirstName || ""}
                                                                                                        onChange={(e) =>
                                                                                                            this.handleMemberChange(
                                                                                                                index,
                                                                                                                mIndex,
                                                                                                                "FirstName",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                    />
                                                                                                    <span className="text-danger">{member.FirstNameErr}</span>
                                                                                                </div>

                                                                                                {/* Last Name */}
                                                                                                <div className="col-md-6">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        disabled={is_view}
                                                                                                        placeholder="Last Name"
                                                                                                        value={member.LastName || ""}
                                                                                                        onChange={(e) =>
                                                                                                            this.handleMemberChange(
                                                                                                                index,
                                                                                                                mIndex,
                                                                                                                "LastName",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                    />
                                                                                                    <span className="text-danger">{member.LastNameErr}</span>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* <hr className="my-3" /> */}

                                                        {/* Dates */}
                                                        {/* <div className="col-md-4">
                                                            <label className="form-label">
                                                                Check In Date <span className="text-danger">*</span>
                                                            </label>
                                                            <DatePicker
                                                                selected={checkInDate}
                                                                className="form-control"
                                                                    disabled={is_view}
                                                                dateFormat="dd/MM/yyyy"
                                                                onChange={(date) =>
                                                                    this.setState({
                                                                        checkInDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                        checkInDateErr: ""
                                                                    })
                                                                }
                                                            />
                                                            <span className="text-danger">{checkInDateErr}</span>
                                                        </div> */}

                                                        {/* Buttons */}
                                                        <div className="d-flex justify-content-end gap-2 mt-2">
                                                            {!is_view &&
                                                                <button className="btn btn-aqua px-4"
                                                                    //  onClick={this.handleSubmit}
                                                                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                                                >
                                                                    Submit
                                                                </button>
                                                            }
                                                            <button className="btn btn-gray px-4" onClick={this.onCancleForm}>
                                                                Back
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div className="modal-header bg-aqua text-white py-2">
                                <h5 class="modal-title modal_title_text">Package Details</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false })} ></button>
                            </div>
                            <div class="modal-body">
                                <p className="m-1">
                                    <strong>Package Includes:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[2]?.length > 0 &&
                                            HotelDetailsList[2].map((item, index) => (
                                                <li key={index}>
                                                    {item.Package || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                                <p className="m-1">
                                    <strong>Basic Facilities:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[3]?.length > 0 &&
                                            HotelDetailsList[3].map((item, index) => (
                                                <li key={index}>
                                                    {item.BasicFacility || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                                <p className="m-1">
                                    <strong>Additional Amenities:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[4]?.length > 0 &&
                                            HotelDetailsList[4].map((item, index) => (
                                                <li key={index}>
                                                    {item.AdditionalAmenities || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }

}


export default withRouter(connect(null, {
    fill_action, getUserHotelEnquiry_action,
    insertHotelEnquiry_action, getHotelDetails_action, insertUpdateHotelBookinForm_action, getHotelBookinFormDetails_action
})(HotelBookingForm));